const UPLOAD_CONFIG = {
  MAX_UPLOAD: 5000,
  MAX_FILES: 10,
  SIZE: 8388608,
  SUPPORTED_FORMATS: ['text/csv'],
  TICKET_SUPPORTED_FORMATS: {
    CSV: {label: 'CSV', value: 'text/csv'},
    PDF: {label: 'PDF', value: 'application/pdf'},
    XLSX: {
      label: 'XLSX',
      value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    XLS: {label: 'XLS', value: 'application/vnd.ms-excel'},
    PNG: {label: 'PNG', value: 'image/png'},
    JPG: {label: 'JPG', value: 'image/jpg'},
    JPEG: {label: 'JPEG', value: 'image/jpeg'},
  },
}

const STATUS_ADD_TO_A1_BATCH = {
  ACTIVE_BOX: {
    SMART: 'smart',
    CREATE: 'create',
    EXISTING: 'existing',
  },
  ACTION: {
    CREATE: 'create',
    EXCLUDE: 'exclude',
    MOVE: 'move',
  },
}

const A1_BATCH_STATUS = {
  OPEN: 'open',
  SHIPPED: 'shipped',
}

const OPTIONS_JOURNEY_INFO = {
  INCOMPLETE: {label: 'INCOMPLETE', value: 'false'},
  COMPLETE: {label: 'COMPLETE', value: 'true'},
}

const OPTIONS_JOURNEY_STATUS: Record<
  string,
  {
    label: string
    value: (string | null)[]
    color: string
  }
> = {
  N_A: {label: 'N_A', value: [null], color: '#FF7272'},
  READY: {label: 'READY', value: ['ready'], color: '#FFE310'},
  PICK_UP_DROP_OFF: {
    label: 'PICK_UP_DROP_OFF',
    value: ['pickup_dropoff', 'picked_up', 'air_delivery'], // Value 1 is Status Primary, Value 2 is Status Hidden
    color: '#B5C200',
  },
  AIR_DELIVERY: {
    label: 'AIR_DELIVERY',
    value: ['air_delivery_arranged'],
    color: '#6E9E5C',
  },
  CUSTOMS: {label: 'CUSTOMS', value: ['customs'], color: '#0C7345'},
  TRANSFERRED_TO_LOCAL_CARRIER: {
    label: 'TRANSFERRED_TO_LOCAL_CARRIER',
    value: ['transferred'],
    color: '#003A96',
  },
  DELIVERY_STATUS: {label: 'DELIVERY_STATUS', value: ['delivery_status'], color: '#1E2A3B'},
}

const AIRPORT_CODES = [
  {label: 'SZX', value: 'SZX'},
  {label: 'PEK', value: 'PEK'},
  {label: 'SHA', value: 'SHA'},
  {label: 'HAN (Vietnam)', value: 'HAN'},
  {label: 'LAX', value: 'LAX'},
  {label: 'ORD', value: 'ORD'},
  {label: 'JFK', value: 'JFK'},
  {label: 'ATL', value: 'ATL'},
]

export const AIRPORT_COORDINATES: Record<string, {lat: number; lng: number}> = {
  SZX: {lat: 22.6393, lng: 113.8107},
  PEK: {lat: 40.0801, lng: 116.5846},
  SHA: {lat: 31.1979, lng: 121.3363},
  HAN: {lat: 21.2142, lng: 105.8042},
  LAX: {lat: 33.9416, lng: -118.4085},
  ORD: {lat: 41.9742, lng: -87.9073},
  JFK: {lat: 40.6413, lng: -73.7781},
  ATL: {lat: 33.6407, lng: -84.4277},
}

const OPTIONS_A1_SERVICE = {
  ALL_IN_ONE: {
    label: 'A1_ALL_IN_ONE',
    value: 'all_in_one',
  },
  CUSTOMIZE: {
    label: 'CUSTOMIZE',
    value: 'customize',
    isDisabled: true,
  },
}

const PARAMS_A1_BATCHES_FILTER = [
  'date_from',
  'date_to',
  'code',
  'name',
  'readied',
  'journey_info',
  'journey_status',
  'origin',
  'destination',
]

const PARAMS_A1_BATCHES_DETAIL_TABLE_FILTER = [
  'search_text',
  'date_from',
  'date_to',
  'order_date',
  'container_id',
  'content',
  'hts_code',
  'country_of_origin',
  'release_status',
  'customer',
  'order_ref',
  'item_sku',
  'item_name',
  'service',
  'package_info',
]

const MASS_UPDATE = {
  SHIP_TO: {label: 'SHIP_TO', value: 'to'},
  CONTENT: {label: 'CONTENT', value: 'content'},
  DESCRIPTION: {label: 'DESCRIPTION', value: 'description'},
  HTS_CODE: {label: 'HTS_CODE', value: 'hs_tariff_number'},
  CONTAINER_ID: {label: 'CONTAINER_ID', value: 'container_id'},
  COUNTRY_OF_ORIGIN: {label: 'COUNTRY_OF_ORIGIN', value: 'country'},
  QUANTITY: {label: 'QUANTITY', value: 'quantity'},
  VALUE: {label: 'VALUE_$', value: 'value'},
  SERVICE: {label: 'SERVICE', value: 'service'},
}

const OPTIONS_RELEASE_STATUS = {
  INCOMPLETE: {label: 'INCOMPLETE', value: 'incomplete'},
  READY: {label: 'READY', value: 'ready'},
  HOLD: {label: 'HOLD', value: 'hold'},
  REJECTED: {label: 'REJECTED', value: 'rejected'},
  INFORMAL_RELEASED: {label: 'INFORMAL_RELEASED', value: 'informal_released'},
  FORMAL_RELEASED: {label: 'FORMAL_RELEASED', value: 'formal_released'},
  MANUAL_RELEASED: {label: 'MANUAL_RELEASED', value: 'manual_released'},
  DESTROYED: {label: 'DESTROYED', value: 'destroyed'},
}

const TICKET_STATUS = {
  ALL: {label: 'ALL', value: ''},
  OPEN: {label: 'OPEN', value: 'open'},
  RESOLVED: {label: 'CLOSED', value: 'resolved'},
}

const PARAMS_TICKET_FILTER = [
  'modal',
  'id',
  'search_text',
  'status',
  'sender',
  'date_from',
  'date_to',
]
export const A1_ORDERS_OPTION_RELEASE_STATUS = (({
  HOLD,
  REJECTED,
  FORMAL_RELEASED,
  INFORMAL_RELEASED,
  MANUAL_RELEASED,
  DESTROYED,
}) => ({
  HOLD,
  REJECTED,
  FORMAL_RELEASED,
  INFORMAL_RELEASED,
  MANUAL_RELEASED,
  DESTROYED,
}))(OPTIONS_RELEASE_STATUS)

const A1_CONSTANTS = {
  UPLOAD_CONFIG,
  STATUS_ADD_TO_A1_BATCH,
  A1_BATCH_STATUS,
  OPTIONS_JOURNEY_INFO,
  OPTIONS_JOURNEY_STATUS,
  AIRPORT_CODES,
  OPTIONS_A1_SERVICE,
  PARAMS_A1_BATCHES_FILTER,
  PARAMS_A1_BATCHES_DETAIL_TABLE_FILTER,
  MASS_UPDATE,
  OPTIONS_RELEASE_STATUS,
  TICKET_STATUS,
  PARAMS_TICKET_FILTER,
  A1_ORDERS_OPTION_RELEASE_STATUS,
}

export default A1_CONSTANTS
